import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function ConfrontationBlock() {
  return <SectionWrapper data-id="element-22">
      <div className="max-w-[680px] mx-auto text-center space-y-4" data-id="element-23">
        <p className="text-2xl md:text-3xl font-serif text-text leading-tight" data-id="element-24">
          Seguir reaccionando también tiene un costo.
        </p>
        <p className="text-lg md:text-xl text-text-secondary leading-relaxed" data-id="element-25">
          No siempre se ve en dinero. Pero se siente en tu energía.
        </p>
      </div>
    </SectionWrapper>;
}